export default "__VITE_ASSET__Dwp$Sjhj__"